__turbopack_context__.v({
  "card": "checklistitem-module-scss-module__r-PsSG__card",
  "checked": "checklistitem-module-scss-module__r-PsSG__checked",
  "chevron": "checklistitem-module-scss-module__r-PsSG__chevron",
  "iconWrapper": "checklistitem-module-scss-module__r-PsSG__iconWrapper",
  "left": "checklistitem-module-scss-module__r-PsSG__left",
  "stepNumber": "checklistitem-module-scss-module__r-PsSG__stepNumber",
  "subtitle": "checklistitem-module-scss-module__r-PsSG__subtitle",
  "textItems": "checklistitem-module-scss-module__r-PsSG__textItems",
  "title": "checklistitem-module-scss-module__r-PsSG__title",
  "warning": "checklistitem-module-scss-module__r-PsSG__warning",
  "warningLabel": "checklistitem-module-scss-module__r-PsSG__warningLabel",
});
